import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import translationEN from './locales/en/translation.json';
import translationESMX from './locales/es-MX/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  // Map generic Spanish to Mexican Spanish by default
  es: {
    translation: translationESMX
  },
  'es-MX': {
    translation: translationESMX
  }
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language

    // Limit to supported languages and allow non-explicit matching (es-419 -> es)
    supportedLngs: ['en', 'es', 'es-MX'],
    nonExplicitSupportedLngs: true,

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // React i18next options
    react: {
      useSuspense: false
    }
  });

export default i18n;